import React                from "react";
import {HBox}               from "@sirius/ui-lib/src/blocks/Layout";
import {block}              from "./block";
import {TFootProps}         from "./@types";

export const TFoot: React.FC<TFootProps> = ({
    el
}) =>
     <HBox className={block.el('tfoot-wrapper')}>
        {el && React.cloneElement(el.props.children)}
     </HBox>
;
